import React, { useState } from "react";
import "../Styles/PhysicalAttributesForm.css";
import HeightWeightModal from "./HeightWeightModal";

const PhysicalAttributesForm = ({
  height,
  setHeight,
  weight,
  setWeight,
  skinToneList,
  selectedSkinTone,
  handelDataFromSkinToneModal,
  physicalbuildList,
  selectedBuild,
  handelDataFromBuildModal,
}) => {
  const [unit, setUnit] = useState("imperial");
  const [showHeightModal, setShowHeightModal] = useState(false);

  return (
    <div className="PhysicalAttributesForm-form-container">
      <h2 className="background-section__title">Physical Attributes</h2>

      <form className="PhysicalAttributesForm-attributes-form px-4">
        <div className="d-flex justify-content-between ">
          {/* Height */}
          <div className="PhysicalAttributesForm-form-row ">
            <label className="PhysicalAttributesForm-form-label">Height</label>
            <div className="PhysicalAttributesForm-input-group">
              <div
                className="PhysicalAttributesForm-form-input"
                onClick={() => setShowHeightModal(true)}
              >
                {height ? `${height} ft` : "Choose Height (ft.in)"}
              </div>
              <span className="PhysicalAttributesForm-unit-label">Ft</span>
            </div>
          </div>

          {/* Weight */}
          <div className="PhysicalAttributesForm-form-row">
            <label className="PhysicalAttributesForm-form-label">Weight</label>
            <div className="PhysicalAttributesForm-input-group">
              <div
                className="PhysicalAttributesForm-form-input"
                onClick={() => setShowHeightModal(true)}
              >
                {weight ? `${weight} KG` : "Choose Weight (KG)"}
              </div>
              <span className="PhysicalAttributesForm-unit-label">Kg</span>
            </div>
          </div>
        </div>
        {/* Skin Tone */}
        <div className="PhysicalAttributesForm-form-row">
          <label className="PhysicalAttributesForm-form-label">Skin tone</label>
          <select
            className="PhysicalAttributesForm-form-select"
            onChange={handelDataFromSkinToneModal}
            value={selectedSkinTone}
          >
            <option value="">Select SkinTone</option>
            {skinToneList.map((q) => (
              <option key={q.SkinToneId} value={q.SkinToneId}>
                {q.SkinToneName}
              </option>
            ))}
          </select>
        </div>

        {/* Build */}
        <div className="PhysicalAttributesForm-form-row">
          <label className="PhysicalAttributesForm-form-label">
            Select Build
          </label>
          <select
            className="PhysicalAttributesForm-form-select"
            onChange={handelDataFromBuildModal}
            value={selectedBuild}
          >
            <option value="">Select Build</option>
            {physicalbuildList.map((q) => (
              <option key={q.BuildId} value={q.BuildId}>
                {q.BuildName}
              </option>
            ))}
          </select>
        </div>
      </form>
      <HeightWeightModal
        visible={showHeightModal}
        initialHeight={height}
        initialWeight={weight}
        onClose={() => setShowHeightModal(false)}
        onDone={(h, w) => {
          setHeight(h);
          setWeight(w);
        }}
      />
    </div>
  );
};

export default PhysicalAttributesForm;
